import { Typography } from '@euler/app/components/typography';
import { EmptyView } from '@euler/components/EmptyView';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingLeaderboardView } from '@euler/model/coaching-progress';
import { memo } from 'react';
import { RefreshControl, ScrollView, View } from 'react-native';
import { CardNotice } from '../../ai-suite/components/ChatCard';
import { aiColors } from '../../ai-suite/theme';
import { LeaderboardRow } from './components/LeaderboardRow';

/**
 * 本周练习榜: the store's top ten this week, and the trainee's own place
 * pinned below when they are further down. Nobody sees the bottom.
 */
export const LeaderboardView = memo(
  ({
    board,
    failed,
    onRefresh,
  }: {
    board: CoachingLeaderboardView;
    /** The last refresh did not load; the board shown is the one before. */
    failed: boolean;
    onRefresh: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const ownInTop =
      board.own != null &&
      board.top.some(x => x.memberId === board.own!.memberId);
    return (
      <ScrollView
        refreshControl={
          <RefreshControl refreshing={false} onRefresh={onRefresh} />
        }
        contentContainerStyle={{
          width: '100%',
          maxWidth: rpx(640),
          alignSelf: 'center',
          padding: rpx(16),
          gap: rpx(12),
        }}
      >
        <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
          按本周拿到的星和完成的练习次数排名，每周一重新开始。
        </Typography.Text>
        {failed ? (
          <CardNotice tone="danger" text="练习榜没刷新成功，请稍后再试。" />
        ) : null}
        {board.top.length ? (
          <View
            style={{
              borderRadius: rpx(14),
              borderWidth: 1,
              borderColor: aiColors.border,
              backgroundColor: aiColors.card,
              padding: rpx(6),
            }}
          >
            {board.top.map(x => (
              <LeaderboardRow
                key={x.memberId}
                entry={x}
                own={x.memberId === board.own?.memberId}
              />
            ))}
          </View>
        ) : (
          <EmptyView
            message="这周还没有人练习，做第一个上榜的吧"
            noFullHeight
          />
        )}
        {board.own && !ownInTop ? (
          <View
            style={{
              borderRadius: rpx(14),
              borderWidth: 1,
              borderColor: aiColors.border,
              backgroundColor: aiColors.card,
              padding: rpx(6),
            }}
          >
            <LeaderboardRow entry={board.own} own pinned />
          </View>
        ) : null}
        {!board.own && board.top.length ? (
          <Typography.Text
            size={rpx(13)}
            color={aiColors.mutedForeground}
            style={{ textAlign: 'center' }}
          >
            这周还没练习，练一次就能上榜。
          </Typography.Text>
        ) : null}
      </ScrollView>
    );
  },
);
